import { defineAsyncComponent } from "vue";
import type { TileConfigType } from "@/modules/tiles/tileConfigs";
import { markRaw } from "vue";

export const tileConfigs: TileConfigType = {
  ChartTile: {
    active: true,
    settingsModule: markRaw(
      defineAsyncComponent(() => import("./components/Tile/Settings/ChartTileSettings.vue")),
    ),
    component: markRaw(defineAsyncComponent(() => import("./components/Tile/ChartTile.vue"))),
    icon: "fas fa-chart-line",
  },
};
